export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es', 'cat'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: '7c3fb42c-0379-4c67-8a90-f79485bd5934',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'casatarradellasambtu.alares',

  /**
  * Nombre de la app
  */
  appName: 'CASA TARRADELLAS AMB TU',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-DDJ8RNC710',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: true,

  /** Registro habilitado o deshabilitado */
  registration: false,
  videoCallsUrl: 'https://videollamada.vivofacil.com/?kid=AljJRe39SLEsWhMFg2pqTrA',
  mailTransport: 'alares',
  brandName: 'Alares',
  appUrlTld: 'es',
  

  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: true
};
